export const chatMessage = (data) => {
  return {
    data,
    type: 'chat:message',
  }
}
